import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from "primereact/radiobutton";
import { Col, Form, Row } from 'react-bootstrap';
import ShowVideo from '../shared/ShowVideo';


export default function StudentSelector(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [confirmResetPassVisible, setConfirmResetPassVisible] = useState(false);


  const [currentItem, setCurrentItem] = useState(null);
  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const LoadingRows = Array.from({ length: 5 });

  const [oldUserRole, setOldUserRole] = useState(0);
  const [selectedUserRole, setSelectedUserRole] = useState(null);
  const [userRole, setUserRole] = useState(0);
  const [nationalId, setNationalId] = useState("");
  const [mobile, setMobile] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    searchUsers();
  }, []);

  const searchUsers = function () {
    var sText = "";
    if (searchText != null) {
      sText = searchText;
    }
  

    setLoading(true);
    var params = { login: util.getTrustedUser(), lastIndex: 0, pageSize: 0, includeTeacher:true, includeAssistant:true, searchText: sText };
    var url = config.Server + `/user/school/user/list`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          console.log("response is>", response);

          setItems(response);
          setFilterItems(response);

          setLoading(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });

  }
  const addNewItem = function () {
    setCurrentItem(null);
    setOldUserRole(0);
    var ur = {name:'معلم', code:"4"};
    setSelectedUserRole(ur);
    setUserRole(4);
    setNationalId("");
    setMobile("");
    setFirstname("");
    setLastname("");
    setEditFormVisible(true);
  }
  const onRowEditClick = function (row) {
    setCurrentItem(row);
    var ur = {name:row.role.title, code:row.role.id.toString()};
    console.log("ur is>", ur);
    setOldUserRole(row.role.id);
    setSelectedUserRole(ur);
    setUserRole(ur);
    setNationalId(row.user.nationalId);
    setMobile(row.user.mobile);
    setFirstname(row.user.firstname);
    setLastname(row.user.lastname);
    setEditFormVisible(true);
  }
  const onRowResetPassClick = function (row) {
    setCurrentItem(row);
    setConfirmResetPassVisible(true);
  }
  const resetPassItem = function () {
    setDeleting(true);
    var id = currentItem.id;
    var nationalId = currentItem.user.nationalId;
    var params = { login: util.getTrustedUser(), nationalId: nationalId };
    console.log("reser param is>", params)
    var url = config.Server + `/user/school/user/reset-password`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          
          setErrorMessage("رمز همکار با موفقیت به شماره موبایل همکار تغیر یافت");
          setErorVisible(true);
          setCurrentItem(null);

          setDeleting(false);
          setConfirmResetPassVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setDeleting(false);
        }
      })
      .catch(error => {
        setDeleting(false);
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
      });
  }
  const onResetPassConfirm_Accept = function () {
    resetPassItem();
  }
  const onResetPassConfirm_Reject = function () {
    if (deleting) return;
    setConfirmResetPassVisible(false);
  }

  //--------------------------------------
  const onRowDeleteClick = function (row) {
    setCurrentItem(row);
    setConfirmDeleteVisible(true);
  }
  const closeEditDialog = function () {
    setEditFormVisible(false);
  }
  const deleteItem = function () {
    setDeleting(true);
    var id = currentItem.id;
    var nationalId = currentItem.user.nationalId;
    var params = { login: util.getTrustedUser(), nationalId: nationalId, userRole: currentItem.role.id };
    console.log("del param is>", params)
    var url = config.Server + `/user/school/user/delete`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          var tmp = [...items];
          for (var i = 0; i < tmp.length; i++) {
            if (tmp[i].id === id) {
              tmp.splice(i, 1);
              break;
            }
          }
          setCurrentItem(null);
          setItems(tmp);
          setFilterItems(tmp);

          setDeleting(false);
          setConfirmDeleteVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setDeleting(false);
        }
      })
      .catch(error => {
        setDeleting(false);
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
      });
  }
  const onDeleteConfirm_Accept = function () {
    deleteItem();
  }
  const onDeleteConfirm_Reject = function () {
    if (deleting) return;
    setConfirmDeleteVisible(false);
  }

  const checkDataEntry = function () {
    //console.log("user role is>", userRole)
    if (userRole == null || userRole == "" || userRole == "0" || !userRole) {
      setErrorMessage("نقش را انتخاب کنید");
      setErorVisible(true);
      return false;
    }
   if (nationalId.trim().length == 0) {
      setErrorMessage("کد ملی را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if(!util.IsValidNationalCode(nationalId)){
      setErrorMessage("کد ملی را نامعتبر است");
      setErorVisible(true);
      return false;
    }
    if (firstname.trim().length == 0) {
      setErrorMessage("نام را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if (lastname.trim().length == 0) {
      setErrorMessage("نام خانوادگی را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if (mobile.trim().length == 0) {
      setErrorMessage("شماره تلفن را وارد کنید");
      setErorVisible(true);
      return false;
    }
    return true;
  }
  const saveItem = function () {
    if (!checkDataEntry()) return;

    setSaving(true);
    var id = "";
    if (currentItem != null) {
      id = currentItem.user.id;
    }
    var params = { login: util.getTrustedUser(), id:id, nationalId: nationalId, firstname: firstname, lastname: lastname, mobile: mobile, userRole: parseInt(selectedUserRole.code), oldUserRole:oldUserRole };
    var url = config.Server + `/user/school/user/save`;
    console.log("params-->", params);
    console.log("url-->", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  if(id === ""){
                    tmp.push(response);
                  }
                  else{
                    for(var i=0;i<tmp.length;i++){
                      if(tmp[i].id === id){
                        tmp[i] = {
                          nationalId:nationalId, 
                          firstname:firstname,
                          lastname:lastname,
                          mobile:mobile,
                          userRole: parseInt(selectedUserRole.code),
                        }
                        setCurrentItem(tmp[i]);
                        break;
                      }
                    }
                  }
                  setItems(tmp);
                  setFilterItems(tmp);                  
                  setSaving(false);
                  setEditFormVisible(false);
                  searchUsers();
              }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });

  }
  const editDialogFooter = function () {
    return (
      <GeneralDialogFooter onOkClick={() => { saveItem() }} onCancelClick={() => { closeEditDialog() }} saving={saving} />
    )
  }
  const onInputChange = function (e, name) {
    var val = '';
    val = (e.target && e.target.value) || '';
    if (name === "nationalId") setNationalId(val);
    else if (name === "firstname") setFirstname(val);
    else if (name === "lastname") setLastname(val);
    else if (name === "mobile") setMobile(val);
  }

  const onComboChange = function (name, e) {
    console.log("selected is>", e.value)
    if (name === "selectedUserRole") {
      setSelectedUserRole(e.value);
      setUserRole(parseInt(e.value.code));
    }
    return
  }

  const setRowActions = function (row) {
    return (
            <Row className="justify-content-md-center" style={{}}>
              <Button icon="pi pi-pencil" rounded severity="success" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowEditClick(row)} title="ویرایش" />
              <Button icon="pi pi-key" rounded severity="secondary" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowResetPassClick(row)} title="ریست کلمه عبور " />
              <Button icon="pi pi-trash" rounded severity="danger" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowDeleteClick(row)} title="حذف" />
            </Row>
    );
  }
  const userRoles = [
    { name: 'معاون مدرسه', code: '3' },
    { name: 'معلم', code: '4' },
  ];

  return (
    <>
    <ShowVideo videoId="school_teachers" top={65} md={6} /> 
      <div className="card">
        <div className="" style={{}}>
          <div style={{ backgroundColor: '#e9edffff', padding: '5px', borderRadius: '5px', width: "100%", display: 'flow-root' }}>
            <Row>
              <Col md={3} style={{height:"75px", paddingTop:"30px"}}>
                <FloatLabel>
                    <InputText value={searchText} onChange={(e) => { onInputChange(e, "searchText") }} id="searchText" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center", padding: '10px' }} />
                    <label htmlFor="username">جستجو</label>
                </FloatLabel>
              </Col>
            </Row>
            <Row>
              <Col>
                <div style={{float:'right', margin:'10px', display:'block', direction:"ltr", textAlign:"right"}}>
                  <Button label="جستجو" icon="pi pi-search" onClick={()=>searchUsers()} severity="primary" iconPos="right" />
                </div>
                
              </Col>
            </Row>
          </div>
        </div>

        {
          loading ?
            <DataTable value={LoadingRows} className="p-datatable-striped">
              <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
              <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
            </DataTable>
            :
            <>
              <div className="page-caption">لیست معلم و معاون</div>
                <Row style={{}}>
                  <Col md={2}>
                    <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right", margin:"10px" }}>             
                      <Button label="افزودن به لیست" icon="pi pi-plus" onClick={()=>addNewItem()} severity="secondary" iconPos="right" />
                    </div>                
                  </Col>
                </Row>

              <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id" selection={currentItem} onSelectionChange={(e) => { setCurrentItem(e.value) }}>
                <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="user.nationalId" body={(row) => row.user.nationalId} header={"کدملی"} sortable className="list-cell-text-align"></Column>
                <Column field="user.firstname" body={(row) => row.user.firstname} header={"نام"} sortable className="list-cell-text-align"></Column>
                <Column field="user.lastname" body={(row) => row.user.lastname} header={"نام خانوادگی"} sortable className="list-cell-text-align"></Column>
                <Column field="user.mobile" body={(row) => row.user.mobile} header={"شماره تلفن"} sortable className="list-cell-text-align"></Column>
                <Column field="role.title" body={(row) => row.role.title} header={"نقش"} sortable className="list-cell-text-align"></Column>
                <Column body={(row) => setRowActions(row)} exportable={false} style={{ maxWidth: '6rem' }}></Column>
              </DataTable>
            </>
        }
      </div>
      {
        editFormVisible ?
          <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="ثبت معلم و معاون" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => closeEditDialog()}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td>
                    <div className="card flex justify-content-center">
                      <FloatLabel className="w-full md:w-14rem">
                        <Dropdown inputId="dd-city" value={selectedUserRole} onChange={(e) => onComboChange("selectedUserRole", e)} options={userRoles} optionLabel="name" className="w-full" />
                        <label htmlFor="dd-city">نقش</label>
                      </FloatLabel>
                    </div>
                  </td>
                </tr>
                <tr><td colSpan={2}>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={nationalId} onChange={(e) => { onInputChange(e, "nationalId") }} id="nationalId" keyfilter="int" maxLength={10} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="username">کدملی</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={firstname} onChange={(e) => { onInputChange(e, "firstname") }} id="firstname" keyfilter="" maxLength={20} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="username">نام</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={lastname} onChange={(e) => { onInputChange(e, "lastname") }} id="lastname" keyfilter="" maxLength={20} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="username">نام خانوادگی</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={mobile} onChange={(e) => { onInputChange(e, "mobile") }} id="mobile" keyfilter="int" maxLength={11} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="username">شماره تلفن</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
              </tbody>
            </table>

          </Dialog>
          :
          <></>
      }
      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
      <ShowConfirm visible={confirmResetPassVisible} message="آیا از ریست کلمه عبور مطمئن هستید؟" caption="اطمینان از ریست کلمه عبور" onAccept={onResetPassConfirm_Accept} onReject={onResetPassConfirm_Reject} loading={deleting} />
    </>
  );
}
